var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.text)?_c('div',{staticClass:"service-notification",class:_vm.classes},[_c('ion-icon',{staticClass:"service-notification__icon",attrs:{"name":_vm.icon}}),_c('div',{staticClass:"service-notification__text",domProps:{"textContent":_vm._s(_vm.text)}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }